import React, { useEffect, useState, useRef } from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon, FileFieldIcon } from '../../_components'
import { FaBuilding, FaAddressCard, FaUserAlt } from 'react-icons/fa'
import data from '../../fixtures'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { setServicesList, setExperienceProofFiles, setSectionAData } from '../../_slices/AppSlice'
import Axios from 'axios'
import { handleFileChange } from '../../_utils'

export default function SectionB( { handleChange, handleBlur, values, signing } ) {
  const dispatch = useDispatch()
  const ref = useRef(null);
  const state = useSelector( state => {
    return {
      sectionAData: state.application.sectionAData,
      experienceProofFiles: state.application.experienceProofFiles,
    }
  } )

  const [ uploadedExpProof, setUploadedExpProof ] = useState( {} )

  const [ serviceNames, setServiceNames ] = useState( [{ service_name: "" }] )
  const [ skillNames, setSkillNames ] = useState( [{ service_name: "" }] )

  // if( localStorage.getItem( "edit_set" ) === "true" ) {
  //   setServiceNames([{ service_name: "" }])
  // } else{
  //   //
  // }

  const [ servicesDropdown, setServicesDropdown ] = useState( [] )
  const [ skillsDropdown, setSkillsDropdown ] = useState( [] )
  const [ existingFiles, setExistingFiles ] = useState( [] )
  const [ previousSystemFiles, setPreviousSystemFiles ] = useState( [] )
  const [ docSlug, setDocSlug ] = useState( "" )

  useEffect( () => {
    fetchIsicCodes()
    fetchSkillsCodes()
    fetchApplicationDocuments()
    console.log("below are services on edit ===")
    console.log(values.service_name)
    console.log("above are the services")
    if( serviceNames.length > 0 ) {
      // dispatch( setServicesList( { servicesList: services } ) )
    }
  }, [])

  const fetchApplicationDocuments = async () => {
    try {
      const files_response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getApplicationFiles/${localStorage.getItem( "applicationId" )}` )
      if( files_response.data ){
        setExistingFiles( files_response.data?.data )
      }
    } catch (error) {}

    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getPreviousSystemApplicationFiles/${localStorage.getItem( "applicationId" )}` )
      if( response.data ){
        console.log(response.data)
        setPreviousSystemFiles( response.data?.data )
      }
    } catch (error) {}
  }

  const viewPreviousSystemDoc = async (entity_name, docSlug) => {
    // console.log("go to the basket =>>"+docSlug)
    // console.log("go to the basket =>>"+entity_name)
    try {
      const url = process.env.REACT_APP_API_URL+`/api/auth/view_previous_system_doc/${docSlug}/${entity_name}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const previewFile = async (e) => {
    let file_id = e.target.id

    try {
      const email = btoa(localStorage.getItem( "email" )); // Base64 encode
      const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const fetchIsicCodes = async (evt) => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_isic_codes`);
      const et_response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_et_isic_codes`);

      if (localStorage.getItem( "domain" ) === "ET") {
        if( et_response.data.message === "success" ) {
          let isicCodes = et_response.data.db_records
          let isicDbCodes = isicCodes.map((item) => {
            return {
              id: item.id,
              label: `${item.class}: ${item.description}`,
              value: item.class
            }
          }
          );
          setServicesDropdown(isicDbCodes)
        } else{
          console.log("response returned error")
        }
      } else {
        if( response.data.message === "success" ) {
          let isicCodes = response.data.db_records
          let isicDbCodes = isicCodes.map((item) => {
            return {
              id: item.id,
              label: `${item.class}: ${item.description}`,
              value: item.class
            }
          }
          );
          setServicesDropdown(isicDbCodes)
        } else{
          console.log("response returned error")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSkillsCodes = async (evt) => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_skills_codes`);

      if( response.data.message === "success" ) {
        let skillCodes = response.data.db_records
        let skillDbCodes = skillCodes.map((item) => {
          return {
            id: item.id,
            label: `${item.skill_code}: ${item.skill}`,
            value: item.skill_code
          }
        }
        );
        setSkillsDropdown(skillDbCodes)
      } else{
        console.log("response returned error")
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleInputs = ( evt, idx ) => {    
    const newServiceNames = [...serviceNames];
    newServiceNames[idx][evt.target.name] = evt.target.value;
    setServiceNames(newServiceNames);
    dispatch( setSectionAData( {...state.sectionAData, serviceName: serviceNames} ) );
  }

  const handleRemove = idx => {
    const list = [ ...serviceNames ]
    list.splice( idx, 1 )
    return setServiceNames( list )
  }

  const handleAddService = () => {
    if( serviceNames.length < 7 ) {
      return setServiceNames([...serviceNames, { service_name: "" }]); // add another input to the state
    }
    
    return alert( "You can not add more than 7 services" )
  }

  const handleSkillsInputs = ( evt, idx ) => {    
    const newSkillNames = [...skillNames];
    newSkillNames[idx][evt.target.name] = evt.target.value;
    console.log(newSkillNames)
    setSkillNames(newSkillNames);
    dispatch( setSectionAData( {...state.sectionAData, skillName: skillNames} ) );
  }

  const handleSkillsRemove = idx => {
    const list = [ ...skillNames ]
    list.splice( idx, 1 )
    return setSkillNames( list )
  }

  const handleAddSkills = () => {
    if( skillNames.length < 7 ) {
      return setSkillNames([...skillNames, { service_name: "" }]); // add another input to the state
    }
    
    return alert( "You can not add more than 7 skills" )
  }


  const handleChangeApplicationPurpose = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, applicationPurpose: evt.target.value} ) );
  }

  const handleChangeValidity = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, validity: evt.target.value} ) );
  }

  const handleChangeCertificationLevel = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, certification_level: evt.target.value} ) );
  }

  const handleChangeYearsOfExperience = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, experience: evt.target.value} ) );
  }

  const handleFile = ( evt, tag ) => {
    handleFileChange( evt, tag, (response, file ) => {
      if(file.size > 6128180){
        alert("Please make sure that the file size doesn't exceed 5 MBs")
      } else{
        setUploadedExpProof( {
          document: response,
          name: file.name,
          size: file.size,
          tag: tag,
          type: file.type
        })
      }
    })
  }

  const handleFileBlur = (evt) => {
    let savedFile = { 
      file: uploadedExpProof.document, 
      title: uploadedExpProof.name, 
      size: uploadedExpProof.size, 
      tag: uploadedExpProof.tag, 
      type: uploadedExpProof.type, 
    }

    let data = Object.assign( {}, savedFile )

    dispatch(  setExperienceProofFiles( {experienceProofFiles: [ ...state.experienceProofFiles, data ] }) )
  }

  return (
    <>
      {(localStorage.getItem( "edit_set" ) === "true") && (
        <Panel label="Attachments">
        <table className="w-full border">
          <thead className="text-xs bg-gray-200 font-bold p-2">
              <th className="p-2">#</th>
              <th>Name</th>
              <th>Size</th>
              <th>Action</th>
              <th>Date Created</th>
          </thead>
          <tbody>
              {existingFiles?.map( ( item, index ) => {
                  return (
                      <tr className="text-xs p-2 text-center">
                          <td className="p-2">{`${index+1}`}</td>
                          {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                          <td>{item.name} name</td>
                          <td>{item.size}</td>
                          <td>
                            <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a>
                            <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a>
                          </td>
                          <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                      </tr>
                  )
              } )}

              {previousSystemFiles?.map( ( item, index ) => {
                  return (
                    <>
                      {item.trading_licence_doc !== "" && 
                        <tr className="text-xs p-2 text-center">
                            <td className="p-2">{`${index+1}`}</td>
                            {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                            <td>{item.trading_licence_doc} </td>
                            <td></td>
                            <td>
                              <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("trading_licence_doc"); viewPreviousSystemDoc(item.business_trading_name, "trading_licence_doc");}}>View</a>
                              {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                            </td>
                            <td>{moment( item.date_created ).format("DD MMM, YYYY")}</td>
                        </tr>
                      }

                      {item.it_experience_doc && 
                        <tr className="text-xs p-2 text-center">
                            <td className="p-2">{`${index+1}`}</td>
                            {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                            <td>{item.it_experience_doc}</td>
                            <td></td>
                            <td>
                              <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("it_experience_doc"); viewPreviousSystemDoc(item.business_trading_name, "it_experience_doc");}}>View</a>
                              {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                            </td>
                            <td>{moment( item.date_created ).format("DD MMM, YYYY")}</td>
                        </tr>
                      }

                      {item.income_tax_clearance_doc && 
                        <tr className="text-xs p-2 text-center">
                            <td className="p-2">{`${index+1}`}</td>
                            {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                            <td>{item.income_tax_clearance_doc}</td>
                            <td></td>
                            <td>
                              <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={(e) => { setDocSlug("income_tax_clearance_doc"); viewPreviousSystemDoc(item.business_trading_name, "income_tax_clearance_doc");}}>View</a>
                              {/* <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a> */}
                            </td>
                            <td>{moment( item.date_created ).format("DD MMM, YYYY")}</td>
                        </tr>
                      }
                      </>
                  )
              } )}
          </tbody>
        </table>
        </Panel>
      )}
      <Panel label={`Section B: Details of Service Applied For - ${values.category?.toUpperCase()}`}>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
          <SelectFieldIcon 
            name="application_purpose"
            handleChange={evt => {
              handleChange(evt)
              handleChangeApplicationPurpose( evt)
            }}
            handleBlur={handleBlur}
            value={values.application_purpose}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Purpose of Application"
            required={localStorage.getItem( "domain" ) === "ET" ? false : true}
            disabled={signing}
            options={data.purposes.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Purpose of Application" />
          
          { values.application_purpose === "Renewal" &&
            ( <TextFieldIcon 
                type="number"
                name="validity"
                handleChange={evt => {
                  handleChange(evt)
                  handleChangeValidity( evt)
                }}
                handleBlur={handleBlur}
                value={values.validity}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="Validity"
                required={false}
                disabled={signing}
                question="Validity Period for the certificate being renewed" />
          ) }

          {values.category === "Company" && ( 
          <SelectFieldIcon 
            name="certification_level"
            handleChange={evt => {
              handleChange(evt)
              handleChangeCertificationLevel( evt)
            }}
            handleBlur={handleBlur}
            value={values.certification_level}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Certification Level"
            required={localStorage.getItem( "domain" ) === "ET" ? false : true}
            disabled={signing}
            options={data.certification_levels.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Certification Level" /> ) }
          

          <SelectFieldIcon 
            name="experience"
            handleChange={evt => {
              handleChange(evt)
              handleChangeYearsOfExperience( evt)
            }}
            handleBlur={handleBlur}
            value={values.experience}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Years of Experience"
            required={localStorage.getItem( "domain" ) === "ET" ? false : true}
            disabled={signing}
            options={data.experienceyears.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Years of Experience" />


          <FileFieldIcon
            noPadding
            name="proof_experience"
            handleBlur={evt => {
              handleBlur(evt)
              handleFileBlur( evt )
            }}
            //value={values?.proof_experience}
            handleChange={evt => {
              handleChange(evt)
              handleFile( evt, "proof_of_experience" )
            }}
            iconComponent={<FaUserAlt color={`#666`} />}
            label="Proof of Experience in IT Services (Less than 5MB)"
            question="Proof of Experience in IT Services (Less than 5MB)" 
            required={(localStorage.getItem( "domain" ) === "ET" || values.certification_level === "CCL1") ? false : true}
            tooltip="E.g Contracts, LPO e.t.c"
            tooltipExplanation="Attach any document to show proof of experience E.g Contract, LPO, Certificate etc" 
          />

          {/* {localStorage.getItem( "domain" ) === "ITSP" &&
            <SelectFieldIcon 
            name="certification_level"
            handleChange={evt => {
              handleChange(evt)
            }}
            handleBlur={handleBlur}
            value={values.certification_level}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Applying for Level"
            required={true}
            disabled={signing}
            options={[ 
              { id: 1, value: "CCL1", label: "CCL1" },
              { id: 2, value: "CCL2", label: "CCL2" },
              { id: 3, value: "CCL3", label: "CCL3" }
            ]}
            question="Applying for Level" />
          } */}

          {values.certification_level === "CCL3"  && 
            <>
              <TextFieldIcon 
                name="iso_number"
                handleChange={evt => {
                    handleChange(evt)
                }}
                handleBlur={handleBlur}
                value={values.iso_number}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="ISO 20000"
                required={ values.iso_number !== "Ugandan"? true : false}
                disabled={signing}
                question="ISO 20000" />

              <FileFieldIcon
                noPadding
                name="relevant_iso_certificate"
                handleBlur={evt => {
                  handleBlur(evt)
                  handleFileBlur( evt )
                }}
                handleChange={evt => {
                  handleChange(evt)
                  handleFile( evt, "relevant_iso_certificate" )
                }}
                iconComponent={<FaUserAlt color={`#666`} />}
                label="Valid relevant ISO Certificate"
                question="Valid relevant ISO Certificate" 
                required={true}
                tooltip=""
                tooltipExplanation="Attach any document to show proof of experience E.g Contract, LPO, Certificate etc" 
              />
            </>
          }

          {values.certification_level === "CCL2"  && 
            <>
              <FileFieldIcon
                noPadding
                name="technical_manuals"
                handleBlur={evt => {
                  handleBlur(evt)
                  handleFileBlur( evt )
                }}
                handleChange={evt => {
                  handleChange(evt)
                  handleFile( evt, "technical_manuals" )
                }}
                iconComponent={<FaUserAlt color={`#666`} />}
                label="Quality and Technical Manuals / Standard Procedures"
                question="Quality and Technical Manuals / Standard Procedures" 
                required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                tooltip=""
                tooltipExplanation="" 
              />
            </>
          }

          {localStorage.getItem( "domain" ) === "ET"  && 
            <>  
              <div className="p-3">           
              <FileFieldIcon
                noPadding
                name="code_of_conduct"
                handleBlur={evt => {
                  handleBlur(evt)
                  handleFileBlur( evt )
                }}
                handleChange={evt => {
                  handleChange(evt)
                  handleFile( evt, "code_of_conduct" )
                }}
                iconComponent={<FaUserAlt color={`#666`} />}
                label="Code of Conduct"
                question="Code of Conduct" 
                required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                tooltip=""
                tooltipExplanation="Attach any document to show code of conduct" 
              />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="terms_or_conditions_of_agreement"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "terms_or_conditions_of_agreement" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Terms or conditions of agreement"
                  question="Terms or conditions of agreement" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Terms or conditions of agreement" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="complaints_handling_mechanisms"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "complaints_handling_mechanisms" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Internal complaints handling mechanisms"
                  question="Internal complaints handling mechanisms" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Internal complaints handling mechanisms" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="alternative_dispute_res_mechanisms"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "alternative_dispute_res_mechanisms" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Alternative Dispute Resolution mechanisms"
                  question="Alternative Dispute Resolution mechanisms" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Alternative Dispute Resolution mechanisms" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="non_disclosure_agreements"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "non_disclosure_agreements" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Staff confidentiality & non-disclosure agreements"
                  question="Staff confidentiality & non-disclosure agreements" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Staff confidentiality & non-disclosure agreements" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="data_retention_policy"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "data_retention_policy" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Data retention mechanism/policy"
                  question="Data retention mechanism/policy" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Data retention mechanism/policy" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="internal_info_security_awareness_for_staff"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "internal_info_security_awareness_for_staff" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Internal information security awareness for staff"
                  question="Internal information security awareness for staff" 
                  required={localStorage.getItem( "edit_set" ) === "true" ? false : true}
                  tooltip=""
                  tooltipExplanation="Internal information security awareness for staff" 
                />
              </div>

              <div className="p-3">
                <FileFieldIcon
                  noPadding
                  name="additional_eta_documents"
                  handleBlur={evt => {
                    handleBlur(evt)
                    handleFileBlur( evt )
                  }}
                  handleChange={evt => {
                    handleChange(evt)
                    handleFile( evt, "additional_eta_documents" )
                  }}
                  iconComponent={<FaUserAlt color={`#666`} />}
                  label="Additional Documents"
                  question="Additional Documents" 
                  required={false}
                  tooltip=""
                  tooltipExplanation="Additional Documents" 
                />
              </div>
            </>
          }
            
        </div>
      </Panel>
      <Panel label={`Section B: Services`}>
        
        {values.category === "Individual"  && 
          (<>
            <div className="flex flex-row items-center justify-center w-24">
              <button onClick={() => handleAddSkills()} type="button" 
                className="bg-purple-500 text-xs rounded-sm text-white px-2 py-1">
                {`Add Skill`}
              </button>
            </div>

            {skillNames.map( (item, idx ) => {
            return (
              <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
              <SelectFieldIcon 
                name="service_name"
                handleChange={evt => {
                  handleChange( evt, idx )
                  handleSkillsInputs( evt, idx )
                }}
                handleBlur={handleBlur}
                value={skillNames[idx].service_name}
                iconComponent={<FaBuilding color={`#AFC836`} />} 
                label="Skill Code"
                required={true}
                disabled={signing}
                options={skillsDropdown.map( ( { id, label, value } ) => {
                  return { id, label, value }
                } )}
                question="Skill Code" 
              />
  
              <div className="flex items-center justify-center w-14">
                {idx > 0 && ( <button onClick={() => handleSkillsRemove( idx )} type="button" 
                  className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                  {`Remove`}
                </button> ) }
              </div>
            </div>)
          })}
          </>)
        }

        {values.category === "Company"  && (
          <>
            <div className="flex flex-row items-center justify-center w-24">
              <button onClick={() => handleAddService()} type="button" 
                className="bg-purple-500 text-xs rounded-sm text-white px-2 py-1">
                {`Add Service`}
              </button>
            </div>

            {serviceNames.map( (item, idx ) => {
              return (
                <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                <SelectFieldIcon 
                  name="service_name"
                  handleChange={evt => {
                    handleChange( evt, idx )
                    handleInputs( evt, idx )
                  }}
                  handleBlur={handleBlur}
                  value={serviceNames[idx].service_name}
                  iconComponent={<FaBuilding color={`#AFC836`} />} 
                  label="Service ISIC Code"
                  required={true}
                  disabled={signing}
                  options={servicesDropdown.map( ( { id, label, value } ) => {
                    return { id, label, value }
                  } )}
                  question="Service ISIC Code" 
                />

                <div className="flex items-center justify-center w-14">
                  {idx > 0 && ( <button onClick={() => handleRemove( idx )} type="button" 
                    className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                    {`Remove`}
                  </button> ) }
                </div>
              </div>)
            })}
          </>
        )}
            

        {/* {services.map( (item, idx ) => {
          return (
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
              <TextFieldIcon 
                type="text"
                name="service_name"
                handleChange={ ( evt ) => handleInputs( evt, idx ) }
                handleBlur={handleBlur}
                value={item.service_name}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="Service Name"
                required={false}
                disabled={signing}
                question="Service Name" />

              <div className="flex items-center justify-center w-14">
                {idx > 0 && ( <button onClick={() => handleRemove( idx )} type="button" 
                  className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                  {`Remove`}
                </button> ) }
              </div>
            </div>
          )
        } )} */}
      </Panel>
    </>
  )
}
